import { ArrowRight, MousePointerClick } from "lucide-react";
import { BathymetricCanvas } from "../BathymetricCanvas";
import { Overline, PrimaryButton, SecondaryButton } from "../Shared";
import { IMAGES } from "../../lib/assets";
import { STATS } from "../../lib/data";

export const scrollToDemo = (e) => {
  e.preventDefault();
  const el = document.getElementById("sample-map");
  if (!el) return;
  window.history.replaceState(null, "", "/#sample-map");
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 96, behavior: "smooth" });
};

const HeroStats = () => (
  <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-2xl">
    {STATS.map((s) => (
      <div key={s.label} data-testid={`hero-stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}>
        <div className="text-2xl sm:text-3xl font-extrabold text-cyan-300 font-mono">{s.value}</div>
        <div className="text-xs text-slate-300 mt-1 uppercase tracking-wider">{s.label}</div>
      </div>
    ))}
  </div>
);

export const HomeHero = () => (
  <section className="relative min-h-screen flex items-center overflow-hidden pb-28 bg-[#0A0F1D]" data-testid="hero-section">
    <div className="absolute inset-0">
      <img src={IMAGES.hero} alt="Reservoir with bathymetric map overlay" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0F1D]/90 via-[#0A0F1D]/75 to-[#0A0F1D]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1D] via-transparent to-transparent" />
    </div>
    <BathymetricCanvas className="absolute inset-0 w-full h-full opacity-50" />

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-24">
      <div className="max-w-3xl animate-fade-up">
        <Overline light>Full-Service Lake &amp; Reservoir Mapping</Overline>
        <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-white">
          Precision maps of{" "}
          <span className="bg-gradient-to-r from-cyan-300 to-teal-300 bg-clip-text text-transparent text-glow">
            everything beneath the surface
          </span>
        </h1>
        <p className="mt-6 text-lg sm:text-xl text-slate-100 leading-relaxed max-w-2xl">
          Lake Monitor AI comes to your waterbody, collects survey-grade sonar data, and delivers finished
          depth, vegetation, habitat and GIS maps. We do the work — you get the insight.
        </p>
        <div className="mt-9 flex flex-wrap gap-4">
          <PrimaryButton to="/#sample-map" onClick={scrollToDemo} tone="hero" testId="hero-try-demo-button">
            <MousePointerClick className="w-4 h-4" /> Try the interactive map
          </PrimaryButton>
          <SecondaryButton to="/request-a-quote" tone="hero" testId="hero-request-quote-button">
            Request a Quote <ArrowRight className="w-4 h-4" />
          </SecondaryButton>
        </div>
        <HeroStats />
      </div>
    </div>
  </section>
);
